/* unplugin-vue-components disabled */import script from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"

import "./FileUpload.vue?vue&type=style&index=0&id=b5f182c4&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f182c4"]])

export default __exports__